function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
import { listApi, createApi, updateApi, deleteApi, getCardsApi, checkCanDeleteApi } from './api';
import { STATUS_OPTIONS, formatStatus, formatCards } from './enum';
export default {
  data: function data() {
    // 校验福卡包名称是否重复
    var validatePackageName = function validatePackageName(rule, value, callback) {
      if (!value) {
        callback(new Error('请输入福卡包名称'));
      } else {
        // 在实际接口中，后端会验证重复性
        callback();
      }
    };
    return {
      tableData: {
        list: [],
        total: 0
      },
      pageFrom: {
        page: 1,
        limit: 20,
        keyword: '',
        cardId: undefined,
        status: undefined
      },
      loading: false,
      // 表格loading
      dialogVisible: false,
      // 新增/编辑对话框
      dialogTitle: '新增福卡包',
      // 对话框标题
      confirmDeleteVisible: false,
      // 删除确认对话框
      deleteItemId: null,
      // 要删除的项ID

      cardList: [],
      // 可选的福卡列表
      form: {
        id: '',
        // 编辑时的ID
        name: '',
        // 福卡包名称
        internalName: '',
        // 内部名称
        status: 1,
        // 状态：1-启用，0-禁用
        usageDesc: '',
        // 使用说明
        cardIds: [],
        // 包含的福卡ID
        themeColor: '',
        // 主题色
        cardStyle: '',
        // 卡片样式图片
        exchangeConfigId: null // 兑换页配置ID
      },
      rules: {
        name: [{
          required: true,
          validator: validatePackageName,
          trigger: 'blur'
        }],
        internalName: [{
          required: true,
          message: '请输入内部名称',
          trigger: 'blur'
        }],
        cardIds: [{
          required: true,
          type: 'array',
          message: '请选择包含的福卡',
          trigger: 'change'
        }]
      },
      statusOptions: STATUS_OPTIONS
    };
  },
  methods: {
    // 搜索
    search: function search() {
      this.pageFrom.page = 1;
      this.getList();
    },
    // 改变每页条数
    handleSizeChange: function handleSizeChange(size) {
      this.pageFrom.limit = size;
      this.getList();
    },
    // 改变页码
    pageChange: function pageChange(page) {
      // 保证页码不会超出实际范围
      var maxPage = Math.ceil(this.tableData.total / this.pageFrom.limit) || 1;
      this.pageFrom.page = Math.min(page, maxPage);
      this.getList();
    },
    // 获取列表
    getList: function () {
      var _getList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var params, res, list, total, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              this.loading = true;
              _context.p = 1;
              // 将前端参数转换为后端API需要的格式 (CardPackageSearchRequest)
              params = {
                page: this.pageFrom.page,
                limit: this.pageFrom.limit,
                keyword: this.pageFrom.keyword || undefined,
                cardId: this.pageFrom.cardId || undefined,
                status: this.pageFrom.status
              };
              _context.n = 2;
              return listApi(params);
            case 2:
              res = _context.v;
              if (!res) {
                _context.n = 4;
                break;
              }
              // 处理返回的数据，映射为组件需要的格式
              list = res.list || [];
              total = res.total || 0; // 修正分页计算 - 确保最后一页有数据
              if (!(total > 0 && list.length === 0 && this.pageFrom.page > 1)) {
                _context.n = 3;
                break;
              }
              console.log('Empty last page detected, going back to previous page');
              this.pageFrom.page = Math.ceil(total / this.pageFrom.limit);
              // 重新调用获取数据
              return _context.a(2, this.getList());
            case 3:
              this.tableData = {
                list: this.formatResponseList(list),
                total: total
              };
              _context.n = 5;
              break;
            case 4:
              this.$message.error(res.message || '获取列表失败');
              this.tableData = {
                list: [],
                total: 0
              };
            case 5:
              _context.n = 7;
              break;
            case 6:
              _context.p = 6;
              _t = _context.v;
              console.error('获取福卡包列表失败', _t);
              this.$message.error('获取福卡包列表失败');
              this.tableData = {
                list: [],
                total: 0
              };
            case 7:
              _context.p = 7;
              this.loading = false;
              return _context.f(7);
            case 8:
              return _context.a(2);
          }
        }, _callee, this, [[1, 6, 7, 8]]);
      }));
      function getList() {
        return _getList.apply(this, arguments);
      }
      return getList;
    }(),
    // 格式化返回的列表数据
    formatResponseList: function formatResponseList(list) {
      var _this = this;
      return list.map(function (item) {
        // 解析卡片名称字符串为对象数组
        var cards = item.cardNames ? _this.parseCardNames(item.cardNames) : [];

        // 如果有cardIds数组，确保卡片列表包含正确的ID
        if (item.cardIds && Array.isArray(item.cardIds)) {
          // 将cardIds保存到cards数组中
          for (var i = 0; i < cards.length; i++) {
            if (i < item.cardIds.length) {
              cards[i].id = Number(item.cardIds[i]);
            }
          }
        }
        return {
          id: item.id,
          name: item.name,
          internalName: item.internalName,
          status: item.status.toString(),
          // 转为字符串以兼容现有代码
          description: item.usageDesc,
          cards: cards,
          cardIds: item.cardIds,
          // 保存原始cardIds数组
          createTime: _this.formatDate(item.createTime),
          // 需要调用checkCanDelete接口来确定是否可删除
          hasIssuedCards: false // 默认值，在openDeleteConfirm时会检查
        };
      });
    },
    // 解析卡片名称字符串
    parseCardNames: function parseCardNames(cardNamesStr) {
      if (!cardNamesStr) return [];

      // 处理类似于 "特权卡, 通兑卡1, 未登录默认卡片, 套餐卡" 的格式
      try {
        return cardNamesStr.split(',').map(function (item) {
          var name = item.trim();
          return {
            id: 0,
            name: name
          }; // 初始ID为0，后续会被cardIds数组更新
        });
      } catch (err) {
        console.error('解析卡片名称失败', err);
        return [];
      }
    },
    // 格式化日期
    formatDate: function formatDate(dateStr) {
      if (!dateStr) return '';
      var date = new Date(dateStr);
      return date.toLocaleString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
      }).replace(/\//g, '-');
    },
    // 获取福卡列表
    getCardList: function () {
      var _getCardList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              console.log('Calling getCardsApi...');
              _context2.n = 1;
              return getCardsApi();
            case 1:
              res = _context2.v;
              console.log('API Response:', res);
              if (!(res && Array.isArray(res))) {
                _context2.n = 2;
                break;
              }
              // 转换为组件需要的格式，匹配FudouCard模型
              this.cardList = res.map(function (card) {
                return {
                  id: card.id,
                  name: "".concat(card.id, " - ").concat(card.cardName || card.name || "\u5361\u7247".concat(card.id))
                };
              });
              console.log('Card list populated:', this.cardList);
              return _context2.a(2, this.cardList);
            case 2:
              console.error('Invalid API response:', res);
              this.$message.error(res && res.message || '获取卡片列表失败');
              this.cardList = [];
              return _context2.a(2, []);
            case 3:
              _context2.n = 5;
              break;
            case 4:
              _context2.p = 4;
              _t2 = _context2.v;
              console.error('获取福卡列表失败', _t2);
              this.$message.error('获取福卡列表失败');
              this.cardList = [];
              return _context2.a(2, []);
            case 5:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 4]]);
      }));
      function getCardList() {
        return _getCardList.apply(this, arguments);
      }
      return getCardList;
    }(),
    // 打开新增对话框
    openAddDialog: function () {
      var _openAddDialog = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              this.dialogTitle = '新增福卡包';
              this.resetForm();
              this.dialogVisible = true;
              _context3.n = 1;
              return this.getCardList();
            case 1:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function openAddDialog() {
        return _openAddDialog.apply(this, arguments);
      }
      return openAddDialog;
    }(),
    // 打开编辑对话框
    openEditDialog: function () {
      var _openEditDialog = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(row) {
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              this.dialogTitle = '编辑福卡包';
              this.resetForm();

              // 填充表单数据
              this.form = {
                id: row.id,
                name: row.name,
                internalName: row.internalName,
                status: parseInt(row.status),
                usageDesc: row.description,
                cardIds: (row.cards || []).map(function (card) {
                  return card.id;
                }),
                themeColor: row.themeColor,
                cardStyle: row.cardStyle || '',
                exchangeConfigId: row.exchangeConfigId || null
              };
              this.dialogVisible = true;
              _context4.n = 1;
              return this.getCardList();
            case 1:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function openEditDialog(_x) {
        return _openEditDialog.apply(this, arguments);
      }
      return openEditDialog;
    }(),
    // 重置表单
    resetForm: function resetForm() {
      this.form = {
        id: '',
        name: '',
        internalName: '',
        status: 1,
        usageDesc: '',
        cardIds: [],
        themeColor: '',
        cardStyle: '',
        exchangeConfigId: null
      };
      if (this.$refs.form) {
        this.$refs.form.clearValidate();
      }
    },
    // 关闭对话框
    handleClose: function handleClose() {
      this.dialogVisible = false;
      this.resetForm();
    },
    // 提交表单
    submitForm: function () {
      var _submitForm = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var _this2 = this;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              this.$refs.form.validate(/*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(valid) {
                  var formData, res, _t3;
                  return _regenerator().w(function (_context5) {
                    while (1) switch (_context5.p = _context5.n) {
                      case 0:
                        if (valid) {
                          _context5.n = 1;
                          break;
                        }
                        return _context5.a(2);
                      case 1:
                        _context5.p = 1;
                        _this2.loading = true;

                        // 转换表单数据为后端需要的格式 (CardPackageRequest)
                        formData = {
                          id: _this2.form.id || null,
                          name: _this2.form.name,
                          internalName: _this2.form.internalName,
                          status: _this2.form.status,
                          usageDesc: _this2.form.usageDesc,
                          cardIds: _this2.form.cardIds,
                          themeColor: _this2.form.themeColor,
                          cardStyle: _this2.form.cardStyle,
                          exchangeConfigId: _this2.form.exchangeConfigId || null
                        }; // 调用接口
                        if (!formData.id) {
                          _context5.n = 3;
                          break;
                        }
                        _context5.n = 2;
                        return updateApi(formData);
                      case 2:
                        res = _context5.v;
                        _this2.$message.success('编辑成功');
                        _this2.handleClose();
                        _this2.getList();
                        _context5.n = 5;
                        break;
                      case 3:
                        _context5.n = 4;
                        return createApi(formData);
                      case 4:
                        res = _context5.v;
                        _this2.$message.success('新增成功');
                        _this2.handleClose();
                        _this2.getList();
                      case 5:
                        _context5.n = 7;
                        break;
                      case 6:
                        _context5.p = 6;
                        _t3 = _context5.v;
                        console.error('保存失败', _t3);
                        _this2.$message.error('保存失败');
                      case 7:
                        _context5.p = 7;
                        _this2.loading = false;
                        return _context5.f(7);
                      case 8:
                        return _context5.a(2);
                    }
                  }, _callee5, null, [[1, 6, 7, 8]]);
                }));
                return function (_x2) {
                  return _ref.apply(this, arguments);
                };
              }());
            case 1:
              return _context6.a(2);
          }
        }, _callee6, this);
      }));
      function submitForm() {
        return _submitForm.apply(this, arguments);
      }
      return submitForm;
    }(),
    // 打开删除确认对话框
    openDeleteConfirm: function () {
      var _openDeleteConfirm = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(id) {
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              this.loading = true;
              try {
                this.deleteItemId = id;
                this.confirmDeleteVisible = true;
              } catch (err) {
                console.error('检查删除条件失败', err);
                this.$message.error('检查删除条件失败');
              } finally {
                this.loading = false;
              }
            case 1:
              return _context7.a(2);
          }
        }, _callee7, this);
      }));
      function openDeleteConfirm(_x3) {
        return _openDeleteConfirm.apply(this, arguments);
      }
      return openDeleteConfirm;
    }(),
    // 执行删除
    confirmDelete: function () {
      var _confirmDelete = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
        var res, _t4;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.p = _context8.n) {
            case 0:
              if (this.deleteItemId) {
                _context8.n = 1;
                break;
              }
              return _context8.a(2);
            case 1:
              _context8.p = 1;
              this.loading = true;

              // 调用删除接口
              _context8.n = 2;
              return deleteApi(this.deleteItemId);
            case 2:
              res = _context8.v;
              this.$message.success('删除成功');
              this.getList();
              _context8.n = 4;
              break;
            case 3:
              _context8.p = 3;
              _t4 = _context8.v;
              console.error('删除失败', _t4);
            case 4:
              _context8.p = 4;
              this.loading = false;
              this.confirmDeleteVisible = false;
              this.deleteItemId = null;
              return _context8.f(4);
            case 5:
              return _context8.a(2);
          }
        }, _callee8, this, [[1, 3, 4, 5]]);
      }));
      function confirmDelete() {
        return _confirmDelete.apply(this, arguments);
      }
      return confirmDelete;
    }(),
    // 格式化状态
    formatStatus: formatStatus,
    // 格式化包含的福卡
    formatCards: formatCards
  },
  created: function created() {
    this.getList();
  }
};